"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var EvaluationKey;
(function (EvaluationKey) {
    EvaluationKey[EvaluationKey["DURATION"] = 0] = "DURATION";
    EvaluationKey[EvaluationKey["REINFORCEMENT"] = 1] = "REINFORCEMENT";
    EvaluationKey[EvaluationKey["ACCURACY"] = 2] = "ACCURACY";
    EvaluationKey[EvaluationKey["SPEED"] = 3] = "SPEED";
    EvaluationKey[EvaluationKey["CURVE"] = 4] = "CURVE";
})(EvaluationKey = exports.EvaluationKey || (exports.EvaluationKey = {}));
var QuestionCriteriaType;
(function (QuestionCriteriaType) {
    QuestionCriteriaType[QuestionCriteriaType["DEFAULT"] = 0] = "DEFAULT";
    QuestionCriteriaType[QuestionCriteriaType["DURATION"] = 1] = "DURATION";
    QuestionCriteriaType[QuestionCriteriaType["REINFORCEMENT"] = 2] = "REINFORCEMENT";
    QuestionCriteriaType[QuestionCriteriaType["ACCURACY"] = 3] = "ACCURACY";
    QuestionCriteriaType[QuestionCriteriaType["SPEED"] = 4] = "SPEED";
    QuestionCriteriaType[QuestionCriteriaType["CURVE"] = 5] = "CURVE";
})(QuestionCriteriaType = exports.QuestionCriteriaType || (exports.QuestionCriteriaType = {}));
var TotalLessonCount;
(function (TotalLessonCount) {
    TotalLessonCount[TotalLessonCount["C1_AND_C2"] = 42] = "C1_AND_C2";
    TotalLessonCount[TotalLessonCount["C9X"] = 9] = "C9X";
})(TotalLessonCount = exports.TotalLessonCount || (exports.TotalLessonCount = {}));
//# sourceMappingURL=evaluation.js.map


//////////////////
// WEBPACK FOOTER
// ../core/dist/src/types/evaluation.js
// module id = 446
// module chunks = 0